<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Financial Position 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col md="5" lg="5" xl="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col md="6" lg="6" xl="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th style="min-width:250px">Description</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">{{filter.tgltahunlalu | moment("MMM YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Tahun lalu</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Jan {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Jan</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Feb {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Feb</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Mar {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Mar</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Apr {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Apr</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">May {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">May</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Jun {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Jun</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Jul {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Jul</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Aug {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Aug</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Sep {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Sep</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Oct {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Oct</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Nov {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Nov</th>
                            <th v-if="filter.tgl2" style="text-align:right; width:100px;">Dec {{filter.tgl2 | moment("YYYY")}}</th>
                            <th v-if="!filter.tgl2" style="text-align:right; width:100px;">Dec</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.sdawal | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row, row.jan,1)" style="text-align:right">{{row.jan | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row, row.feb,2)" style="text-align:right">{{row.feb | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.mar,3)" style="text-align:right">{{row.mar | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.apr,4)" style="text-align:right">{{row.apr | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.mei,5)" style="text-align:right">{{row.mei | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jun,6)" style="text-align:right">{{row.jun | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jul,7)" style="text-align:right">{{row.jul | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.agt,8)" style="text-align:right">{{row.agt | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.sep,9)" style="text-align:right">{{row.sep | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.okt,10)" style="text-align:right">{{row.okt | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.nov,11)" style="text-align:right">{{row.nov | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonthly(row,row.des, 12)" style="text-align:right">{{row.des | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

        <b-modal v-model="drillConfirmation" scrollable size="md" title="Drilldown Confirmation" hide-footer>
            <span>Show Detail value of <strong>{{drillSrc.uraianfmt}}</strong> , month of <strong>{{monthLabels[monthOf-1] }}</strong> ?</span>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="drillNewtab" class="mt-1 ml-2">Open New Tab</b-form-checkbox>
            <b-row class="justify-content-center mt-1">
                <b-button variant="primary" class="ml-2" @click="drillAction('GL')" > Show in GL</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('TB')" > Show in TB</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('MODUL')" v-if="(drillModul)"> Show in subModul</b-button>
                <b-button variant="secondary" class="ml-2" @click="drillConfirmation=false" > Cancel</b-button>
            </b-row>
        </b-modal>
    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import fp from "../../apis/fp";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'',tgl1:'',tgl2:''},
      isLoading: false,
      layouts:[{value: 'AUTOALLACCOUNT', text: 'ALL ACCOUNT'}],
      monthLabels:["January","February","March","April","May","Juni","July","August","September","October","November","December"],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[],
      drillConfirmation:false,
      drillSrc:{}, drillCol:'', monthOf:'', 
      drillModul:'',drillNewtab:1

    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
        const lines = await fp.fp12mlayout({layout : newval, tahun: this.tahun});
        const hasil = lines.reduce((newArr, line) => {
            if (line.item_hapus !== 1) newArr.push(line);
            return newArr;
        }, []);          
          this.rptLines=hasil;
      }
  },
created: async function (){
    const ll  = await fp.layout_combo();
    this.layouts= this.layouts.concat(ll);
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.tahun=moment(tgl2).format('YYYY');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
    this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        // this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // const tglbulanlalu = moment(query.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
    this.filter.tglbulanini= tgl2;
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.tahun=moment(tgl2).format('YYYY');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
        this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        // this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tglbulanini= tgl2;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.rptLines= await fp.fp12m(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await fp.fp12mprint(model);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                const response = await fp.fp12mexport(model);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Financial_position_12Months_${model.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillMonthly: function(data,nilai, monthOf)
    {
        if ((data.kode) && (nilai)) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.monthOf=monthOf;
            this.drillConfirmation=true;
                // this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, month of ${this.monthLabels[monthOf-1].toUpperCase() } ?`, {
                // title: 'Drilldown Confirmation',
                // size: 'sm',
                // buttonSize: 'sm',
                // okVariant: 'danger',
                // okTitle: 'YES',
                // cancelTitle: 'NO',
                // footerClass: 'p-2',
                // hideHeaderClose: false,
                // centered: true
                // })
                // .then(value => {
                //     if (value==true) {
                //         var tgl1 = moment(`${this.tahun}-${monthOf}-01`,'YYYY-MM-DD');
                //         let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl1.format('YYYY-MM-DD')}/${tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}`});
                //         window.open(routeData.href, '_blank');
                //     }
                // })
                // .catch(err => {
                //     console.log('msgBoxConfirm error', err);
                // })


        }
    },
    cekModule: function(kodeacc) {
        this.drillModul='';
        if (kodeacc.startsWith('140')) {
            this.drillModul='receivable.araging';
        } else if (kodeacc.startsWith('141')) {
            this.drillModul='advance.advaging';
        } else if (kodeacc.startsWith('142')) {
            this.drillModul='accounting.loanaraging';
        } else if (kodeacc.startsWith('150')) {
            this.drillModul='logistic.rptbalance';
        } else if (kodeacc.startsWith('210')) {
            this.drillModul='payable.apsummary';
        }    
    },
    drillAction(drillTarget){
        let drillRoute;
        var tgl1 = moment(`${this.tahun}-${this.monthOf}-01`,'YYYY-MM-DD');
        switch (drillTarget) {
            case 'TB':
                drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl1.format('YYYY-MM-DD')}`, tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}}
                break;
        
            case 'MODUL':
                drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl1.format('YYYY-MM-DD')}`, tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}}
                
                break;
        
            default:
                drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl1.format('YYYY-MM-DD')}`, tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}}
                break;
        }
        if (drillRoute) {
            if (this.drillNewtab==1) {
                const routeData = router.resolve(drillRoute);
                window.open(routeData.href, '_blank');
            } else {
                router.push(drillRoute);                
            }
        }
    },

    close(){
      router.push("home");
    }
  }
};
</script>
